import i18n from './config';

import { normalizeLanguage } from './constants';



function pickString(value: unknown): string | undefined {

  if (typeof value === 'string' && value.trim()) return value.trim();

  return undefined;

}



function collapseWhitespace(value: string): string {

  return value.replace(/\s+/g, ' ').trim();

}



/** Exact English API messages → errors.json code keys. */

const MESSAGE_TO_ERROR_CODE: Record<string, string> = {

  'Email and password are required': 'EMAIL_PASSWORD_REQUIRED',

  'Email and password are required.': 'EMAIL_PASSWORD_REQUIRED',

  'Invalid email or password': 'INVALID_CREDENTIALS',

  'Invalid email or password.': 'INVALID_CREDENTIALS',

  'Login failed': 'LOGIN_FAILED',

  'Login failed.': 'LOGIN_FAILED',

  'Account is inactive': 'ACCOUNT_INACTIVE',

  'Account is inactive.': 'ACCOUNT_INACTIVE',

  'Refresh token is required': 'REFRESH_TOKEN_REQUIRED',

  'Refresh token is required.': 'REFRESH_TOKEN_REQUIRED',

  'First name and last name are required': 'REGISTRATION_NAME_REQUIRED',

  'First name and last name are required.': 'REGISTRATION_NAME_REQUIRED',

  'Tenant ID is required': 'TENANT_ID_REQUIRED',

  'Tenant ID is required.': 'TENANT_ID_REQUIRED',

  'TenantId is required.': 'TENANT_ID_REQUIRED',

  'TenantId is required': 'TENANT_ID_REQUIRED',

  'Email is required': 'EMAIL_REQUIRED',

  'Email is required.': 'EMAIL_REQUIRED',

  'Token and new password are required': 'RESET_TOKEN_REQUIRED',

  'Token and new password are required.': 'RESET_TOKEN_REQUIRED',

  'Invalid or expired reset token': 'INVALID_RESET_TOKEN',

  'Invalid or expired reset token.': 'INVALID_RESET_TOKEN',

  'Failed to reset password': 'PASSWORD_RESET_FAILED',

  'Failed to reset password.': 'PASSWORD_RESET_FAILED',

  'API Key is required': 'API_KEY_REQUIRED',

  'Missing user identity': 'MISSING_IDENTITY',

  'Missing user identity.': 'MISSING_IDENTITY',

  'Old password and new password are required': 'PASSWORD_REQUIRED',

  'New password must be different from old password': 'PASSWORD_SAME_AS_OLD',

  'Failed to change password. Please check your current password.':

    'PASSWORD_CHANGE_FAILED',

  'UserIds cannot be empty': 'ASSIGNMENT_USER_IDS_REQUIRED',

  'DeviceIds cannot be empty': 'ASSIGNMENT_DEVICE_IDS_REQUIRED',

  'UserId and DeviceId are required': 'ATTENDANCE_FIELDS_REQUIRED',

  'The target date is inside a closed pay period. Submit an adjustment request.':
    'PAY_PERIOD_LOCKED',

  'Pay period overlaps an existing period.': 'PAY_PERIOD_OVERLAPS',

  'Pay period overlaps an existing period': 'PAY_PERIOD_OVERLAPS',

  'Cannot close pay period while unresolved review items exist.':
    'PAY_PERIOD_OPEN_REVIEWS',

  'Cannot close pay period while unresolved review items exist':
    'PAY_PERIOD_OPEN_REVIEWS',

  'Pay period not found.': 'PAY_PERIOD_NOT_FOUND',

  'Pay period not found': 'PAY_PERIOD_NOT_FOUND',

  "'ToDate' must be on or after 'FromDate'.": 'PAY_PERIOD_INVALID_RANGE',

  '4-eyes rule: requester cannot approve own adjustment.': 'ADJUSTMENT_FOUR_EYES_BLOCKED',

  'Only submitted requests can be approved.': 'ADJUSTMENT_APPROVE_SUBMITTED_ONLY',

  'Only submitted requests can be rejected.': 'ADJUSTMENT_REJECT_SUBMITTED_ONLY',

  'Only approved adjustments can be applied.': 'ADJUSTMENT_APPLY_APPROVED_ONLY',

  'Delete adjustments require TargetAttendanceId.': 'ADJUSTMENT_DELETE_TARGET_REQUIRED',

  'Attendance record to delete was not found.': 'ADJUSTMENT_DELETE_TARGET_NOT_FOUND',

  'Attendance record to delete was not found': 'ADJUSTMENT_DELETE_TARGET_NOT_FOUND',

  'Update adjustments require an existing attendance record.': 'ADJUSTMENT_UPDATE_TARGET_REQUIRED',

  'Adjustment request not found.': 'ADJUSTMENT_NOT_FOUND',

  'LeaveType is required when exception Type is Leave.': 'SCHEDULE_LEAVE_TYPE_REQUIRED',

  'A schedule exception already exists for this user and date.': 'SCHEDULE_EXCEPTION_EXISTS',

  'Only pending exceptions can be approved.': 'SCHEDULE_EXCEPTION_APPROVE_PENDING_ONLY',

  'Only pending exceptions can be rejected.': 'SCHEDULE_EXCEPTION_REJECT_PENDING_ONLY',

  '4-eyes rule violation: creator cannot approve.': 'SCHEDULE_FOUR_EYES_BLOCKED',

  '4-eyes rule violation: creator cannot reject.': 'SCHEDULE_FOUR_EYES_BLOCKED',

  'Reject reason is required.': 'SCHEDULE_REJECT_REASON_REQUIRED',

  'This day does not require admin review.': 'REVIEW_NOT_REQUIRED',

  'Reason is required.': 'REASON_REQUIRED',

  'Reason is required': 'REASON_REQUIRED',

  'Invalid bulk attendance event data': 'ATTENDANCE_INVALID_BULK_DATA',

  'JMBG must be exactly 13 digits.': 'JMBG_INVALID',

  'Card number must be at most 20 characters.': 'CARD_NUMBER_TOO_LONG',

  'User with this email already exists': 'EMAIL_ALREADY_EXISTS',

  'Cannot delete tenant with existing users or devices': 'TENANT_DELETE_BLOCKED',

  'Cannot delete device with existing attendance records': 'DEVICE_DELETE_BLOCKED',

  'Tenant with this ID already exists': 'TENANT_ALREADY_EXISTS',

  'Request body is required': 'DEVICE_REQUEST_BODY_REQUIRED',

  'Specified worker was not found': 'DEVICE_WORKER_NOT_FOUND',

  'Worker not found for this device': 'WORKER_DEVICE_NOT_FOUND',

  'Department not found': 'DEPARTMENT_NOT_FOUND',

  'Department not found.': 'DEPARTMENT_NOT_FOUND',

  'TenantId is required when creating a department as SuperAdmin.':

    'DEPARTMENT_TENANT_ID_REQUIRED',

  'TenantId is required in the request body when creating a user as Super Admin.':

    'SUPERADMIN_USER_TENANT_REQUIRED',

  'Command not found': 'COMMAND_NOT_FOUND',

  'Command not found or cannot be cancelled': 'COMMAND_CANCEL_BLOCKED',

  'Command cannot be retried': 'COMMAND_RETRY_NOT_ALLOWED',

  'Internal server error': 'INTERNAL_ERROR',

  'tenantId is required': 'INTEGRATION_TENANT_ID_REQUIRED',

  'sinceId must be zero or positive': 'INTEGRATION_SINCE_ID_INVALID',

  'Device not found': 'DEVICE_NOT_FOUND',

  'Device not found.': 'DEVICE_NOT_FOUND',

  'Tenant not found': 'TENANT_NOT_FOUND',

  'Tenant not found.': 'TENANT_NOT_FOUND',

  'User not found': 'USER_NOT_FOUND',

  'User not found.': 'USER_NOT_FOUND',

  'User not synced to this device': 'USER_NOT_SYNCED_TO_DEVICE',

  'The Phone field is not a valid phone number.': 'PHONE_INVALID',

  'The Phone field is not a valid phone number': 'PHONE_INVALID',

  'Phone number contains invalid characters': 'PHONE_INVALID',

  'Phone number cannot exceed 20 characters': 'PHONE_INVALID',

  'Phone number cannot exceed 50 characters': 'PHONE_INVALID',

  'Phone number cannot exceed 50 characters.': 'PHONE_INVALID',

  'Attendance record not found': 'ATTENDANCE_NOT_FOUND',

  'Integration client not found': 'INTEGRATION_CLIENT_NOT_FOUND',

  'Integration client or tenant not found': 'INTEGRATION_CLIENT_NOT_FOUND',

  'Integration client, tenant link, or tenant not found': 'INTEGRATION_LINK_NOT_FOUND',

  'You cannot delete your own account.': 'USER_DELETE_SELF',

  'You can only delete users with the User role.': 'USER_DELETE_ROLE_RESTRICTED',

  'CSV file is required': 'IMPORT_CSV_REQUIRED',

  'Only CSV files are supported': 'IMPORT_CSV_ONLY',

  'File size cannot exceed 10 MB': 'IMPORT_FILE_TOO_LARGE',

  'Worker heartbeat requires X-Client-ID (worker ClientId) with a valid API key.':

    'SYNC_UNAUTHORIZED',

  // Feedback Hub + Help analytics
  'Feedback item not found.': 'FEEDBACK_NOT_FOUND',
  'Feedback item not found': 'FEEDBACK_NOT_FOUND',
  'Attachment not found.': 'FEEDBACK_ATTACHMENT_NOT_FOUND',
  'Attachment not found': 'FEEDBACK_ATTACHMENT_NOT_FOUND',
  'Attachment storage is unavailable. Try again later.': 'FEEDBACK_STORAGE_UNAVAILABLE',
  'Allowed file types: png, jpg, jpeg, webp, pdf, txt, csv.': 'FEEDBACK_ATTACHMENT_TYPE',
  'File name is required.': 'FEEDBACK_ATTACHMENT_NAME_REQUIRED',
  'Comment body is required.': 'FEEDBACK_COMMENT_REQUIRED',
  'Reopen requires a comment (min 5 characters).': 'FEEDBACK_REOPEN_COMMENT',
  'Only Resolved/Closed/Shipped items can be reopened.': 'FEEDBACK_REOPEN_STATUS',
  'Only the submitter or an admin may upload attachments.': 'FEEDBACK_ATTACHMENT_UPLOAD_FORBIDDEN',
  'Only the submitter or SuperAdmin may delete attachments.': 'FEEDBACK_ATTACHMENT_DELETE_FORBIDDEN',
  'Only SuperAdmin may post internal comments.': 'FEEDBACK_INTERNAL_COMMENT_FORBIDDEN',
  'Employees cannot open Incidents — ask a TenantAdmin.': 'FEEDBACK_INCIDENT_USER_FORBIDDEN',
  'Employees cannot open Incidents - ask a TenantAdmin.': 'FEEDBACK_INCIDENT_USER_FORBIDDEN',
  'Feature/Improvement has no severity SLA.': 'FEEDBACK_NO_SEVERITY_SLA',
  'Invalid severity.': 'FEEDBACK_INVALID_SEVERITY',
  'RICE applies only to Feature/Improvement.': 'FEEDBACK_RICE_TYPE',
  'RiceReach must be 1–5.': 'FEEDBACK_RICE_REACH',
  'RiceReach must be 1-5.': 'FEEDBACK_RICE_REACH',
  'RiceImpact must be 1–5.': 'FEEDBACK_RICE_IMPACT',
  'RiceImpact must be 1-5.': 'FEEDBACK_RICE_IMPACT',
  'RiceConfidence must be 0–100.': 'FEEDBACK_RICE_CONFIDENCE',
  'RiceConfidence must be 0-100.': 'FEEDBACK_RICE_CONFIDENCE',
  'RiceEffort must be S/M/L/XL.': 'FEEDBACK_RICE_EFFORT',
  'StrategicFit must be 1–5.': 'FEEDBACK_RICE_STRATEGIC',
  'StrategicFit must be 1-5.': 'FEEDBACK_RICE_STRATEGIC',
  'RevenueRisk must be 1–5.': 'FEEDBACK_RICE_REVENUE',
  'RevenueRisk must be 1-5.': 'FEEDBACK_RICE_REVENUE',
  'Only Feature/Improvement can be voted.': 'FEEDBACK_VOTE_NOT_ALLOWED',
  'Only TenantAdmin or SuperAdmin can endorse ideas for the company.': 'FEEDBACK_VOTE_ADMIN_ONLY',
  'This tenant already voted.': 'FEEDBACK_ALREADY_VOTED',
  'No vote from this tenant.': 'FEEDBACK_VOTE_NOT_FOUND',
  'CSAT is only allowed after a terminal status.': 'FEEDBACK_CSAT_STATUS',
  'Only the submitter or tenant admin may rate.': 'FEEDBACK_CSAT_ROLE',
  'CSAT score must be 1–5.': 'FEEDBACK_CSAT_SCORE',
  'CSAT score must be 1-5.': 'FEEDBACK_CSAT_SCORE',
  'CSAT already submitted.': 'FEEDBACK_CSAT_ALREADY',
  'Title must be 10–160 characters.': 'FEEDBACK_TITLE_LENGTH',
  'Title must be 10-160 characters.': 'FEEDBACK_TITLE_LENGTH',
  'Bug/Incident/Security require Expected and Actual behavior.': 'FEEDBACK_EXPECTED_ACTUAL',
  'Reproduction steps require at least 2 steps.': 'FEEDBACK_STEPS_MIN',
  'Reported severity is required (S1–S4).': 'FEEDBACK_SEVERITY_REQUIRED',
  'Reported severity is required (S1-S4).': 'FEEDBACK_SEVERITY_REQUIRED',
  'Impact scope is required.': 'FEEDBACK_IMPACT_REQUIRED',
  'Incident requires StartedAtUtc.': 'FEEDBACK_INCIDENT_STARTED',
  'Incident requires blast radius, business impact, and mitigation tried.': 'FEEDBACK_INCIDENT_FIELDS',
  'Security reports require vulnerability class, exploit public flag, and data classes at risk.':
    'FEEDBACK_SECURITY_FIELDS',
  'TenantAdmin must acknowledge the preflight checklist.': 'FEEDBACK_PREFLIGHT',
  'Feature/Improvement must not include severity (no resolution SLA).': 'FEEDBACK_FEATURE_NO_SEVERITY',
  'Feature/Improvement require a problem statement.': 'FEEDBACK_PROBLEM_REQUIRED',
  'Feature request requires personas benefiting.': 'FEEDBACK_PERSONAS_REQUIRED',
  'Module area is required.': 'FEEDBACK_MODULE_REQUIRED',
  'Too many feedback submissions. Try again later.': 'FEEDBACK_RATE_LIMITED',
  'Remove passwords, API keys, or secrets before submitting.': 'FEEDBACK_SECRETS_DETECTED',
  'Invalid article id.': 'HELP_ARTICLE_INVALID',
  'Rating must be 1–5.': 'HELP_CSAT_RATING',
  'Rating must be 1-5.': 'HELP_CSAT_RATING',
  'No org scope assigned. Contact your administrator.': 'SUPERVISOR_SCOPE_EMPTY',
  'No org scope assigned. Contact your administrator': 'SUPERVISOR_SCOPE_EMPTY',

  'The DelegateUserId field is required.': 'DELEGATION_DELEGATE_REQUIRED',
  'The DelegateUserId field is required': 'DELEGATION_DELEGATE_REQUIRED',
  'The ApproverUserId field is required.': 'DELEGATION_APPROVER_REQUIRED',
  'The ApproverUserId field is required': 'DELEGATION_APPROVER_REQUIRED',
  'The FromDate field is required.': 'DELEGATION_DATES_REQUIRED',
  'The FromDate field is required': 'DELEGATION_DATES_REQUIRED',
  'The ToDate field is required.': 'DELEGATION_DATES_REQUIRED',
  'The ToDate field is required': 'DELEGATION_DATES_REQUIRED',
  'Delegate cannot be the same as the approver.': 'DELEGATION_SAME_PERSON',
  'Delegate cannot be the same as the approver': 'DELEGATION_SAME_PERSON',
  'Approver must be an active supervisor.': 'DELEGATION_APPROVER_INVALID',
  'Approver must be an active supervisor': 'DELEGATION_APPROVER_INVALID',
  'Delegate must be an active supervisor or admin.': 'DELEGATION_DELEGATE_INVALID',
  'Delegate must be an active supervisor or admin': 'DELEGATION_DELEGATE_INVALID',
  'An overlapping active delegation already exists for this pair.': 'DELEGATION_OVERLAP',
  'An overlapping active delegation already exists for this pair': 'DELEGATION_OVERLAP',
  'End date must be on or after start date.': 'DATE_RANGE_INVALID',
  'End date must be on or after start date': 'DATE_RANGE_INVALID',
  'Supervisors can only delegate their own approval.': 'DELEGATION_OWN_ONLY',
  'Supervisors can only delegate their own approval': 'DELEGATION_OWN_ONLY',

};



const CODES_RESOLVE_FROM_MESSAGE = new Set([
  'SHIFT_OPERATION_FAILED',
  'USER_UPDATE_FAILED',
  'USER_CREATE_FAILED',
  'FEEDBACK_VALIDATION_FAILED',
  'FEEDBACK_ATTACHMENT_INVALID',
  'FEEDBACK_INVALID_TRANSITION',
  'FEEDBACK_FORBIDDEN',
  'FEEDBACK_CSAT_NOT_ALLOWED',
  'FEEDBACK_NOT_FOUND',
  'FEEDBACK_VOTE_NOT_ALLOWED',
  'VALIDATION_FAILED',
  'CONFLICT',
  'ACCESS_DENIED',
]);

export function translateErrorCode(code: string, fallbackMessage?: string): string {
  if (!i18n.isInitialized) return fallbackMessage ?? code;

  const trimmedFallback = fallbackMessage ? collapseWhitespace(fallbackMessage) : undefined;

  if (CODES_RESOLVE_FROM_MESSAGE.has(code) && trimmedFallback) {
    const specificCode = resolveCodeFromFreeText(trimmedFallback);
    if (specificCode && specificCode !== code) {
      return i18n.t(`errors:${specificCode}`, { defaultValue: trimmedFallback });
    }
    if (code === 'SHIFT_OPERATION_FAILED') {
      return translateErrorMessage(trimmedFallback, 'SHIFT_OPERATION_FAILED');
    }
    const genericTranslated = i18n.t(`errors:${code}`, { defaultValue: code });
    const fallbackIsGeneric =
      trimmedFallback === code ||
      trimmedFallback === genericTranslated ||
      /^(validation failed|access denied|conflict)\.?$/i.test(trimmedFallback);
    if (!fallbackIsGeneric && !/^[A-Z][A-Z0-9_]+$/.test(trimmedFallback)) {
      const mapped = translateErrorMessage(trimmedFallback, code);
      if (mapped && mapped !== genericTranslated && mapped !== code) {
        return mapped;
      }
      return trimmedFallback;
    }
  }

  const translated = i18n.t(`errors:${code}`, {
    defaultValue: trimmedFallback ?? '',
  });

  return translated || trimmedFallback || code;
}



function resolveCodeFromFreeText(message: string): string | undefined {

  const normalized = collapseWhitespace(message);

  if (MESSAGE_TO_ERROR_CODE[normalized]) return MESSAGE_TO_ERROR_CODE[normalized];

  if (/^[A-Z][A-Z0-9_]+$/.test(normalized) && i18n.exists(`errors:${normalized}`)) {

    return normalized;

  }

  if (/phone.*not a valid|phone number contains invalid|phone number cannot exceed/i.test(normalized)) {

    return 'PHONE_INVALID';

  }

  if (/card number .+ is already in use|card number is already in use/i.test(normalized)) {

    return 'CARD_NUMBER_ALREADY_IN_USE';

  }

  if (/jmbg .+ is already in use|jmbg is already in use/i.test(normalized)) {

    return 'JMBG_ALREADY_IN_USE';

  }

  if (/contains characters that are not allowed|can only contain letters/i.test(normalized)) {

    return 'USER_NAME_INVALID';

  }

  if (/^Content type '.+' is not allowed\.?$/i.test(normalized)) {
    return 'FEEDBACK_CONTENT_TYPE_INVALID';
  }
  if (/^File size must be between 1 byte and \d+ MB\.?$/i.test(normalized)) {
    return 'FEEDBACK_ATTACHMENT_SIZE';
  }
  if (/^Maximum \d+ attachments per feedback item\.?$/i.test(normalized)) {
    return 'FEEDBACK_ATTACHMENT_LIMIT';
  }
  if (/^Reopen window is \d+ days\.?$/i.test(normalized)) {
    return 'FEEDBACK_REOPEN_WINDOW';
  }
  if (/^Unknown status '.+'\.?$/i.test(normalized)) {
    return 'FEEDBACK_UNKNOWN_STATUS';
  }
  if (/^Unknown feedback type '.+'\.?$/i.test(normalized)) {
    return 'FEEDBACK_UNKNOWN_TYPE';
  }
  if (/^Transition .+ → .+ is not allowed for .+\.?$/i.test(normalized)) {
    return 'FEEDBACK_INVALID_TRANSITION';
  }
  if (/^Max \d+ events per batch\.?$/i.test(normalized)) {
    return 'HELP_ANALYTICS_BATCH';
  }
  if (/^Unknown event type '.+'\.?$/i.test(normalized)) {
    return 'HELP_ANALYTICS_UNKNOWN_EVENT';
  }

  const requiredField = normalized.match(/^The (\w+) field is required\.?$/i);
  if (requiredField) {
    const field = requiredField[1];
    if (field === 'DelegateUserId') return 'DELEGATION_DELEGATE_REQUIRED';
    if (field === 'ApproverUserId') return 'DELEGATION_APPROVER_REQUIRED';
    if (field === 'FromDate' || field === 'ToDate') return 'DELEGATION_DATES_REQUIRED';
    return 'FIELD_REQUIRED';
  }

  return undefined;

}



/**

 * Translate a message that may be a raw API English string, an error code, or already localized.

 */

export function translateErrorMessage(

  message: string | undefined | null,

  fallbackCode = 'UNKNOWN_ERROR'

): string {

  if (!message?.trim()) return translateErrorCode(fallbackCode);

  const trimmed = collapseWhitespace(message);



  const fromPattern = resolveCodeFromFreeText(trimmed);

  if (fromPattern) return translateErrorCode(fromPattern, trimmed);



  if (i18n.isInitialized && i18n.exists(`errors:${trimmed}`)) {

    return translateErrorCode(trimmed);

  }

  // Human-readable text (often already localized by extractApiErrorMessage on throw)
  if (!/^[A-Z][A-Z0-9_]+$/.test(trimmed)) {

    return trimmed;

  }



  return translateErrorCode(fallbackCode, trimmed);

}



/** Translate thrown errors / catch blocks. */

export function translateApiError(error: unknown, fallbackCode = 'UNKNOWN_ERROR'): string {

  if (error instanceof Error) {
    const code =
      'errorCode' in error ? pickString((error as { errorCode?: unknown }).errorCode) : undefined;
    if (code) {
      return translateErrorCode(code, error.message);
    }
    return translateErrorMessage(error.message, fallbackCode);

  }

  if (typeof error === 'string') {

    return translateErrorMessage(error, fallbackCode);

  }

  return translateErrorCode(fallbackCode);

}



export function extractApiErrorCode(errorData: unknown): string | undefined {

  if (!errorData || typeof errorData !== 'object') return undefined;

  const o = errorData as Record<string, unknown>;

  return pickString(o.errorCode ?? o.ErrorCode);

}



export function extractApiErrorMessage(errorData: unknown, httpStatus: number): string {

  if (!errorData || typeof errorData !== 'object') {

    return i18n.t('errors:HTTP_ERROR', {

      status: httpStatus,

      defaultValue: `HTTP error! status: ${httpStatus}`,

    });

  }

  const o = errorData as Record<string, unknown>;



  const code = extractApiErrorCode(errorData);

  const topMessage = pickString(o.message ?? o.Message);

  const topDetail = pickString(o.detail ?? o.Detail);

  const primaryText = topMessage ?? topDetail;

  if (primaryText) {
    const fromPattern = resolveCodeFromFreeText(collapseWhitespace(primaryText));
    if (fromPattern) {
      return translateErrorCode(fromPattern, primaryText);
    }
    const codeLike = collapseWhitespace(primaryText);
    if (/^[A-Z][A-Z0-9_]+$/.test(codeLike) && i18n.isInitialized && i18n.exists(`errors:${codeLike}`)) {
      return translateErrorCode(codeLike);
    }
  }

  if (code) {

    const fromCode = translateErrorCode(code, primaryText);

    if (fromCode) return fromCode;

  }



  if (primaryText) {

    const fromText = translateErrorMessage(primaryText, code ?? 'UNKNOWN_ERROR');

    if (fromText) return fromText;

  }



  const errField = o.error;

  if (typeof errField === 'string' && errField.trim() && errField !== 'rate_limit_exceeded') {

    return translateErrorMessage(errField.trim());

  }



  const errors = o.errors;

  if (errors && typeof errors === 'object' && !Array.isArray(errors)) {

    const lines: string[] = [];

    for (const [, raw] of Object.entries(errors as Record<string, unknown>)) {

      if (Array.isArray(raw)) {

        for (const msg of raw) {

          if (typeof msg === 'string' && msg.trim()) lines.push(msg.trim());

        }

      } else if (typeof raw === 'string' && raw.trim()) {

        lines.push(raw.trim());

      } else if (raw != null) {

        lines.push(String(raw));

      }

    }

    if (lines.length > 0) {

      return lines.map((line) => translateErrorMessage(line)).join('\n');

    }

  }



  const title = pickString(o.title ?? o.Title);

  if (title) return translateErrorMessage(title);



  return i18n.t('errors:HTTP_ERROR', {

    status: httpStatus,

    defaultValue: `HTTP error! status: ${httpStatus}`,

  });

}



/** Throw with a translated message from ApiResponse envelope (success=false, HTTP 200). */

export function throwApiResponseError(

  payload: unknown,

  httpStatus = 400,

  fallbackCode = 'OPERATION_FAILED'

): never {

  const code = extractApiErrorCode(payload) ?? fallbackCode;

  const enriched =

    typeof payload === 'object' && payload !== null

      ? { ...(payload as Record<string, unknown>), errorCode: code }

      : { errorCode: code };

  throw Object.assign(new Error(extractApiErrorMessage(enriched, httpStatus)), {
    errorCode: code,
    status: httpStatus,
  });

}



export function getActiveAppLanguage(): string {

  if (typeof window === 'undefined') return normalizeLanguage(undefined);

  return normalizeLanguage(i18n.language || localStorage.getItem('app_language'));

}


